<div class="ghf-wrapper" [class.ghf-collapsed]="collapsed()">

  <button mat-icon-button class="ghf-collapse-btn" (click)="collapsedToggle.emit()"
    [attr.aria-label]="collapsed() ? 'Expand header' : 'Collapse header'">
    <mat-icon>{{ collapsed() ? 'expand_more' : 'expand_less' }}</mat-icon>
  </button>

    <!-- Division label -->
    <div  style="display: flex; flex-direction: column; align-items: start; justify-content: center; ">
        <div class="ghf-division">
            <mat-icon class="ghf-event-icon">view_headline</mat-icon>
            &nbsp;
            {{ Division().Name }}
        </div>
        <!-- <div class="ghf-division"> 
            <mat-icon class="ghf-event-icon">event</mat-icon>
            &nbsp;
            {{ GameDetails().Game.GameDate | date: 'dd' }}
            {{ GameDetails().Game.GameDate | date: 'LLL' }}
            {{ GameDetails().Game.GameTime | date: 'HH:mm' }}  
            @if(GameDetails().Game.Venue) {
                
              - <mat-icon class="ghf-event-icon">stadium</mat-icon>
              {{ GameDetails().Game.Venue }}
            }
            

        </div> -->

<!--       <span class="ghf-tz-badge">{{ GameDetails().Game.ArenaTimeZoneIANA }}</span> -->
        <div class="ghf-division"></div>
    </div>
 

  <!-- Matchup hero -->
  <div class="ghf-matchup">

    <!-- Home team -->
    <div class="ghf-team">
      <img class="ghf-logo" [src]="GameDetails().Game.HomeTeamSmallIcon ? getIconPath(GameDetails().Game.HomeTeamSmallIcon) : '/assets/img/placeholder.png'"  (error)="handleImageError($event)" alt="Home">
      <span class="ghf-team-name">{{ GameDetails().Game.TeamHomeName }}</span>
    </div>

    <!-- Centre: date / time / venue -->
    <div class="ghf-center">
      <div class="ghf-date">
        {{ GameDetails().Game.GameDate | date: 'dd' }}
        {{ GameDetails().Game.GameDate | date: 'LLL' }}
      </div>
      <div class="ghf-time">{{ GameDetails().Game.GameTime | date: 'HH:mm' }}</div>
      <span class="ghf-tz-badge">{{ GameDetails().Game.ArenaTimeZoneIANA }}</span>
      <div class="ghf-venue">{{ GameDetails().Game.Venue }}</div>
    </div>

    <!-- Away team -->
    <div class="ghf-team">
      <img class="ghf-logo" [src]="GameDetails().Game.AwayTeamSmallIcon ? getIconPath(GameDetails().Game.AwayTeamSmallIcon) : '/assets/img/placeholder.png'"  (error)="handleImageError($event)" alt="Away">
      <span class="ghf-team-name">{{ GameDetails().Game.TeamAwayName }}</span>
    </div>

  </div>
  <!-- Team actions -->
  <div class="ghf-actions-row">
    <div class="ghf-team-actions">
      <a matButton="outlined" class="ghf-action-link" [routerLink]="['/team/details', GameDetails().Game.TeamHomeId]">{{ 'GENERAL.DETAILS' | translate }}</a>
      <button matButton="outlined" class="ghf-action-btn" (click)="openSetGradesDialog('home')">{{ 'GAMES.GRADE' | translate }}</button>
    </div>
    <div class="ghf-team-actions">
      <a matButton="outlined" class="ghf-action-link" [routerLink]="['/team/details', GameDetails().Game.TeamAwayId]">{{ 'GENERAL.DETAILS' | translate }}</a>
      <button matButton="outlined" class="ghf-action-btn" (click)="openSetGradesDialog('away')">{{ 'GAMES.GRADE' | translate }}</button>
    </div>
  </div>
  <!-- Score section (only for SweHockey-linked games) -->
  @if (GameDetails().GameLinks[0]?.SourceId == 1) {

    @if (GameDetails().GameStatistics.IsFinalScore != null) {
      <div class="ghf-score-bar">
        <span class="ghf-score-num">{{ GameDetails().GameStatistics.GoalsHome }}</span>

        <button mat-button class="ghf-stats-toggle" (click)="toggleDetailedStats()">
          @if (showDetailedStats) { Hide stats } @else { Show stats }
        </button>

        <span class="ghf-score-num">{{ GameDetails().GameStatistics.GoalsAway }}</span>
      </div>

      @if (showDetailedStats) {
        <div class="ghf-stats-panel">

          @if (GameDetails().GameStatistics.IsFinalScore) {
            <div class="ghf-stat-row ghf-stat-label-row">
              <span></span><span class="ghf-stat-label">FINAL</span><span></span>
            </div>
          }
          @if (!GameDetails().GameStatistics.IsFinalScore && GameDetails().GameStatistics.GameClock) {
            <div class="ghf-stat-row ghf-stat-label-row">
              <span></span>
              <span class="ghf-stat-label">{{ GameDetails().GameStatistics.GameClock }}</span>
              <span></span>
            </div>
          }
          @if (GameDetails().GameStatistics.GameClock) {
            <div class="ghf-stat-row">
              
              <span class="ghf-stat-label">Spectators</span>
              <span>{{ GameDetails().GameStatistics.Spectators }}</span>
            </div>
            <div class="ghf-stat-row">
              <span>{{ GameDetails().GameStatistics.ShotsHome }}</span>
              <span class="ghf-stat-label">Shots</span>
              <span>{{ GameDetails().GameStatistics.ShotsAway }}</span>
            </div>
            <div class="ghf-stat-row">
              <span>{{ GameDetails().GameStatistics.PenaltyTimeHome }}</span>
              <span class="ghf-stat-label">PIM</span>
              <span>{{ GameDetails().GameStatistics.PenaltyTimeAway }}</span>
            </div>
            <div class="ghf-stat-row">
              <span>{{ GameDetails().GameStatistics.SavesHome }}</span>
              <span class="ghf-stat-label">Saves</span>
              <span>{{ GameDetails().GameStatistics.SavesAway }}</span>
            </div>
          }

        </div>
      }
    }

    @if (!GameDetails().GameStatistics.IsFinalScore) {
      <div class="ghf-import-wrap">
        <button mat-raised-button color="primary" [disabled]="isLoadingStats()" (click)="importStats()">
          @if (isLoadingStats()) {
            <mat-spinner diameter="18" style="display:inline-block;vertical-align:middle;margin-right:8px"></mat-spinner>
          } @else {
            <mat-icon>add</mat-icon>
          }
          IMPORT STATS (SWEHOCKEY)
        </button>
      </div>
    }
  }



  <!-- Scheduled events -->
  @if (GameDetails().ScheduledEvents.length > 0) {
    <mat-divider></mat-divider>
    <div class="ghf-events">
      @for (event of GameDetails().ScheduledEvents; track event.EventId) {
        <div class="ghf-event-item">
          <mat-icon class="ghf-event-icon">event</mat-icon>
          <div>
            <span class="ghf-event-name">{{ event.LastName }}, {{ event.FirstName }}</span>
            <div class="ghf-event-comment">{{ event.Comment }}</div>
          </div>
        </div>
      }
    </div>
  }

</div>